export default __webpack_public_path__ + "38ae626914c455e2d07f216f37cec9ea.png";